import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import * as mentorApi from '../../api/mentorApi';

// Change a squad's Introduction session lead (the member who runs the Introduction duties in LMS). Opened from the ESG
// Squads list and from the squad page. The server decides whether it is still allowed (squad.admin_lead_lock tells the
// caller to disable the button up front) and says why when it refuses.
// Rendered into document.body for the same reason as the certificate dialog: the screens sit inside an animated
// (transformed) container, which would otherwise become the containing block of this fixed overlay.
export default function EsgChangeLeadModal({ squad, onClose, onChanged, onSuccess }) {
  const [choice, setChoice] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const candidates = (squad.members || []).filter((m) => m.status === 'active' && m.student_id !== squad.admin_lead?.id);

  const save = async () => {
    setBusy(true);
    setError('');
    try {
      const result = await mentorApi.changeEsgAdminLead(squad.id, Number(choice));
      onSuccess?.('Introduction session lead updated.');
      onChanged?.(result);
      onClose();
    } catch (err) {
      setError(err?.data?.message || "Couldn't change the session lead - please try again.");
      setBusy(false);
    }
  };

  return createPortal(
    <div className="modal-overlay" onClick={busy ? undefined : onClose}>
      <div
        className="modal-card esg-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="esg-change-lead-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="esg-change-lead-title" className="esg-modal-title">Change Introduction session lead</h3>
        <p className="esg-modal-sub">
          {`${squad.name} — current lead: `}<strong>{squad.admin_lead?.name || 'none'}</strong>
        </p>

        <label htmlFor="esg-new-lead" className="esg-modal-label">New session lead</label>
        <select
          id="esg-new-lead"
          className="form-control-select esg-field-full"
          value={choice}
          disabled={busy}
          onChange={(e) => { setError(''); setChoice(e.target.value); }}
        >
          <option value="">Choose a member</option>
          {candidates.map((m) => (
            <option key={m.student_id} value={m.student_id}>{m.student?.name || 'Student'}</option>
          ))}
        </select>

        {error && <div className="rejection-banner esg-mt-12" role="alert">{error}</div>}

        <div className="esg-modal-actions">
          <button type="button" className="esg-btn esg-btn-secondary" disabled={busy} onClick={onClose}>Cancel</button>
          <button type="button" className="esg-btn esg-btn-primary" disabled={!choice || busy} onClick={save}>
            {busy ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
